<template>
  <teleport to="body">
    <Dialog
      v-model:visible="store.isOpen"
      modal
      :header="t('fileSelect.title')"
      :style="{ width: '40rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
      class="file-select-dialog"
      @hide="store.close()"
    >
      <div v-if="store.files.length === 0" class="p-4 text-color-secondary">
        {{ t('fileSelect.empty') }}
      </div>
      <template v-else>
        <div class="flex gap-2 mb-3">
          <Button type="button" :label="t('fileSelect.selectAll')" severity="secondary" size="small" @click="store.selectAll" />
          <Button type="button" :label="t('fileSelect.deselectAll')" severity="secondary" size="small" @click="store.deselectAll" />
        </div>
        <div class="file-list border-1 surface-border border-round overflow-auto" style="max-height: 300px">
          <div
            v-for="file in store.files"
            :key="file.id"
            class="file-row flex align-items-center gap-2 p-2 cursor-pointer border-bottom-1 surface-border hover:surface-hover"
            @click="store.toggle(file.id)"
          >
            <Checkbox
              :model-value="store.isSelected(file.id)"
              :input-id="'file-' + file.id"
              :binary="true"
              @update:model-value="store.toggle(file.id)"
              @click.stop
            />
            <label :for="'file-' + file.id" class="flex-1 cursor-pointer truncate" :title="file.name">
              {{ file.name || file.id }}
            </label>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="flex justify-end gap-2">
          <Button type="button" :label="t('dialogs.cancel')" severity="secondary" @click="store.cancelSelection" />
          <Button type="button" :label="t('dialogs.ok')" @click="store.confirmSelection" :disabled="store.files.length > 0 && selectedCount === 0" />
        </div>
      </template>
    </Dialog>
  </teleport>
</template>

<script setup lang="ts">
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
import { useFileSelectModal } from '@/stores/useFileSelectModal'
import { useI18n } from '@/common/composables/useI18n'
import { computed } from 'vue'

const store = useFileSelectModal()
const { t } = useI18n()

const selectedCount = computed(() => store.files.filter((f) => store.isSelected(f.id)).length)
</script>

<style scoped lang="scss">
.file-select-dialog {
  .file-row {
    transition: background-color 0.15s;
  }
}
</style>
